import _defineProperty from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/builds/aspendental/web/apps/aspendental-clearchoice-compare/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import { Stepper, Step, StepButton, StepConnector } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import Button from '@mui/material/Button';
import ArrowForwardIosRoundedIcon from '@mui/icons-material/ArrowForwardIosRounded';
import ArrowBackIosRoundedIcon from '@mui/icons-material/ArrowBackIosRounded';
import SwipeableViews from 'react-swipeable-views';

var TAGCarousel = function TAGCarousel(_ref) {
  var arrows = _ref.arrows,
      children = _ref.children,
      peeking = _ref.peeking,
      sx = _ref.sx;
  var theme = useTheme();
  var xSmall = useMediaQuery(theme.breakpoints.down('sm'));
  var maxSteps = Array.isArray(children) ? children.length : 1;
  var connector = React.createElement(StepConnector, {
    sx: {
      display: 'none'
    }
  });

  var _React$useState = React.useState(0),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      activeStep = _React$useState2[0],
      setActiveStep = _React$useState2[1];

  var handleStepChange = function handleStepChange(step) {
    setActiveStep(step);
  };

  var handleStep = function handleStep(step) {
    return function () {
      if (activeStep === step) {
        return null;
      }

      setActiveStep(step);
    };
  };

  var handleNext = function handleNext() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep + 1;
    });
  };

  var handleBack = function handleBack() {
    setActiveStep(function (prevActiveStep) {
      return prevActiveStep - 1;
    });
  };

  var SWIPABLE_PROPS = {
    axis: theme.direction === 'rtl' ? 'x-reverse' : 'x',
    index: activeStep,
    onChangeIndex: handleStepChange,
    enableMouseEvents: true
  };

  if (peeking) {
    SWIPABLE_PROPS.style = {
      padding: xSmall ? '0px 29px' : '0px 140px'
    };
    SWIPABLE_PROPS.containerStyle = {
      maxWidth: '600px'
    };
    SWIPABLE_PROPS.slideStyle = {
      padding: '0px 1px'
    };
  }

  return React.createElement(React.Fragment, null, React.createElement(Grid, {
    container: true,
    justifyContent: "center"
  }, arrows && React.createElement(Grid, {
    item: true,
    xs: 1,
    display: "flex",
    justifyContent: "start"
  }, activeStep === 0 ? null : React.createElement(Button, {
    onClick: handleBack,
    disableRipple: true,
    sx: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  }, React.createElement(ArrowBackIosRoundedIcon, {
    sx: {
      fontSize: '44px',
      color: 'secondary.main'
    }
  }))), React.createElement(Grid, {
    xs: 10,
    item: true,
    sx: [peeking && {
      marginLeft: {
        xs: '-15px',
        sm: '0px'
      },
      maxWidth: '880px',
      minWidth: {
        xs: '380px',
        sm: '700px'
      }
    }, {
      mb: '30px'
    }, sx]
  }, React.createElement(SwipeableViews, _objectSpread({
    slideStyle: {
      display: 'flex',
      justifyContent: 'center'
    }
  }, SWIPABLE_PROPS), children)), arrows && React.createElement(Grid, {
    item: true,
    xs: 1,
    display: "flex",
    justifyContent: "end"
  }, activeStep === maxSteps - 1 ? null : React.createElement(Button, {
    onClick: handleNext,
    disableRipple: true,
    sx: {
      '&:hover': {
        backgroundColor: 'transparent'
      }
    }
  }, React.createElement(ArrowForwardIosRoundedIcon, {
    sx: {
      fontSize: '44px',
      color: 'secondary.main'
    }
  })))), React.createElement(Box, {
    display: "flex",
    justifyContent: "center"
  }, React.createElement(Stepper, {
    nonLinear: true,
    activeStep: activeStep,
    connector: connector
  }, Array.isArray(children) && children.map(function (_, index) {
    return React.createElement(Step, {
      key: index
    }, React.createElement(StepButton, {
      disableRipple: true,
      onClick: handleStep(index),
      sx: [{
        '&.MuiStepButton-root': {
          boxSizing: 'border-box',
          padding: '0px',
          margin: '0px',
          '&:hover': {
            cursor: activeStep === index ? 'default' : ''
          }
        },
        '.MuiStepIcon-text': {
          display: 'none'
        },
        '.MuiStepLabel-iconContainer': {
          padding: '0px'
        },
        '.MuiSvgIcon-root': {
          fontSize: '8px',
          color: 'neutrals.dark',
          '&.Mui-active': {
            color: 'secondary.main'
          },
          '&:hover': {
            color: activeStep !== index ? 'secondary.light' : '',
            border: activeStep !== index ? '2px solid' : '',
            borderColor: activeStep !== index ? 'secondary.main' : '',
            boxSizing: 'border-box',
            borderRadius: '50%'
          }
        }
      }, sx]
    }));
  }))));
};

export default TAGCarousel;